/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withNamespaces } from 'react-i18next';
import compose from 'lodash/fp/compose';
import defaultsDeep from 'lodash/defaultsDeep';
import get from 'lodash/get';
import DotComponent from '../../ui/DotComponent';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import Modal from '../../ui/Modal';
import LanguageItem from '../LanguageSelector/LanguageItem';
import * as styles from './index.styles';

const defaultData = {
  Headline: {
    value: 'Choose your language',
  },
  Languages: {
    value: [
      {
        name: '',
        code: '',
        flag: '',
      },
    ],
  },
  ShowModal: {
    value: false,
  },
};

export class LanguageSelectorModal extends SafePureComponent {
  state = {
    isOpen: true,
  };

  renderHeadline = ({ Headline }) => (
    <h2 css={styles.headlineCss}>
      <Text field={Headline} />
      <DotComponent />
    </h2>
  );

  closeModal = () => {
    this.setState({ isOpen: false });
  };

  onClickLanguage = (event, language) => {
    event.preventDefault();
    const { lng } = this.props;
    const { href: currentUrl } = window.location;
    const newUrl = currentUrl.replace(lng, language.code);
    window.open(newUrl, '_self');
  };

  safeRender() {
    const { props } = this;
    const { t } = props;
    const fields = defaultsDeep(props.fields, defaultData);
    const showModal = get(fields, 'ShowModal.value', false);
    const { Languages } = fields;

    if (!showModal) return null;

    return (
      <Modal
        isOpen={this.state.isOpen}
        onRequestClose={this.closeModal}
        overlayProp={styles.overlayModal}
        contentProp={styles.contentModal}
        customCloseButtonCss={styles.closeButton}
      >
        <div css={styles.modalWrapper}>
          <div>{this.renderHeadline(fields)}</div>
          <div css={styles.languagesWrapper}>
            {Languages.value.map(language => (
              <button
                css={styles.countryWrapper}
                key={language.name}
                onClick={event => this.onClickLanguage(event, language)}
              >
                <LanguageItem language={language} t={t} />
              </button>
            ))}
          </div>
        </div>
      </Modal>
    );
  }
}

LanguageSelectorModal.displayName = 'LanguageSelectorModal';

LanguageSelectorModal.defaultProps = {
  t: key => key,
  fields: defaultData,
};

LanguageSelectorModal.propTypes = {
  fields: PropTypes.shape({
    Headline: PropTypes.shape({
      value: PropTypes.string,
    }),
    Languages: PropTypes.shape({
      value: PropTypes.arrayOf([PropTypes.object]),
    }),
    ShowModal: PropTypes.shape({
      value: PropTypes.bool,
    }),
  }),
};

export default compose(
  withNamespaces(),
  withSitecoreContext(),
)(LanguageSelectorModal);
